import { BaseService } from './BaseService';
import { Draft } from '../models';

// Draft Service
export class DraftService extends BaseService {
  constructor() {
    super();
  }

  // Draft API Endpoints

  // 1. Create Draft
  async createDraft(data) {
    return this.post('/drafts', data);
  }

  // 2. Get All Drafts
  async getAllDrafts(includeDeleted = false) {
    const query = includeDeleted ? '?includeDeleted=true' : '';
    return this.get(`/drafts${query}`);
  }

  // 3. Get Single Draft
  async getDraftById(id) {
    return this.get(`/drafts/${id}`);
  }

  // 4. Update Draft
  async updateDraft(id, data) {
    return this.put(`/drafts/${id}`, data);
  }

  // 5. Delete Draft
  async deleteDraft(id, permanent = false) {
    const query = permanent ? '?permanent=true' : '';
    return this.delete(`/drafts/${id}${query}`);
  }

  async bulkDeleteSent() {
    return this.post('/drafts/bulk-delete/sent');
  }

  async bulkDeleteDraft() {
    return this.post('/drafts/bulk-delete/draft');
  }

  async bulkDeletePermanent() {
    return this.post('/drafts/bulk-delete/permanent');
  }
}
